/*
 * If you import `Config` from `@config`, this is the file that will be loaded.
 * You can only access the client environment variables here.
 */
import * as Updates from 'expo-updates'
import { ENV_MAP } from '#/env'

const resolveEnvironment = () => {
	if (!Updates.channel) {
		// @ts-ignore
		return process.env.EXPO_PUBLIC_APP_ENV ?? 'DEV'
	}

	if (Updates.channel === 'production') {
		return 'PROD'
	}

	if (Updates.channel === 'staging') {
		return 'STAGING'
	}

	return 'DEV'
}

const environment = resolveEnvironment()

// @ts-ignore
const Config = ENV_MAP[environment]

export default Config
